import { render, staticRenderFns } from "./salesPriceList.vue?vue&type=template&id=4efcfbc2&scoped=true&"
import script from "./salesPriceList.vue?vue&type=script&lang=js&"
export * from "./salesPriceList.vue?vue&type=script&lang=js&"
import style0 from "./salesPriceList.vue?vue&type=style&index=0&id=4efcfbc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efcfbc2",
  null
  
)

export default component.exports